<div
  class="form-input"
  (clickElsewhere)="closeTooltip()"
  [class.certInput]="certInput"
  [class.employerStage]="employerStage"
>
  @if (!disableLabel) {
    <div class="form-input__header level">
      <div class="level-left" [class.full_xs]="hiddenTooltipOnMobile" (click)="closeTooltip()">
        <label class="form-input__label" [class.center]="centerLabel">
          <span class="form-input__label-tx">{{ label | translate }}</span>
          @if (currencyCode) {
            <span class="form-input__currency-code">({{ setCurrencyCode() }})</span>
          }
        </label>
      </div>
      @if (message) {
        <app-more-info-tooltip
          class="tooltipInInput"
          [class.hidden_xs]="hiddenTooltipOnMobile"
          [isSmallIcon]="true"
          [message]="message"
          [isSmall]="true"
          [showText]="false"
          [additionalDeductions]="true"
          [tooltipInInput]="true"
        ></app-more-info-tooltip>
      }
    </div>
  }
  <div
    class="form-input__content"
    [class.isNotDefault]="isNotDefault"
    [class.active]="activeInput && !textArea"
    [class.notEmpty]="inputChange"
    [class.error]="errors && errors.length"
    [class.is-loading]="isLoading"
  >
    @if (!textArea) {
      <input
        class="form-input__input"
        [type]="getInputType"
        [ngModel]="model"
        [placeholder]="placeholder | translate"
        (blur)="onBlur($event)"
        (focus)="onFocus($event)"
        (ngModelChange)="change($event)"
        [readonly]="isReadonly"
        [disabled]="isDisabled"
        step="0.01"
        [class.form-input--error]="errors && errors.length"
        [class.form-input--verification]="isVerification"
        [class.isEditableSummaryEmployer]="isEditableSummaryEmployer"
        [class.isEmployer]="isEmployer"
        [attr.id]="currentInputId"
        [class.center]="centerTxtInput"
        [ngClass]="addClassB2B ? classB2B : ''"
        [attr.maxlength]="maxLength ? maxLength : null"
        [attr.required]="required ? required : null"
        [attr.autofocus]="autofocus ? autofocus : null"
        [attr.name]="name ? name : null"
        [attr.autocomplete]="autocomplete ? autocomplete : null"
        [attr.inputMode]="inputMode ? inputMode : null"
      />
      @if (appShowPassword) {
        <span
          class="fa fa-fw field-icon"
          (click)="showPasswordToggle()"
          [ngClass]="showPassword ? 'fa-eye' : 'fa-eye-slash'"
        ></span>
      }
      @if (iconSrc) {
        <span class="field-icon pt-0_5"><img src="{{ iconSrc }}" alt="Input icon" /></span>
      }
    }
    @if (textArea) {
      <textarea
        class="form-input__textarea"
        [ngModel]="model"
        [placeholder]="placeholder | translate"
        (blur)="onBlur($event)"
        (focus)="onFocus($event)"
        (ngModelChange)="change($event)"
        [disabled]="isDisabled"
        [class.form-input--error]="errors && errors.length"
        [class.form-input--verification]="isVerification"
        [class.isEmployer]="isEmployer"
        [class.center]="centerTxtInput"
        [ngClass]="addClassB2B ? classB2B : ''"
      ></textarea>
    }
    @if (isCurrency || currencyCode) {
      <span
        class="form-input__currency"
        [class.isNotDefault]="isNotDefault"
        [class.isVerification]="isVerification"
        [class.isEditableSummaryEmployer]="isEditableSummaryEmployer"
        >{{ setCurrencyCode() }}</span
      >
    }
  </div>
  @if (errors && shouldRenderErrors) {
    <div class="form-input__error">{{ errors[0] }}</div>
  }
</div>
